import React, { useEffect } from 'react'
import s from "./dashboard.module.css"
import Maps from './maps/Maps'
import { TfiSignal } from "react-icons/tfi";
import { TfiBolt } from "react-icons/tfi";
import { PiWaves } from "react-icons/pi";
import { IoWaterOutline } from "react-icons/io5";
import { useGetPlacesMutation, useGetTreeMutation, useGetMapQuery } from '../../app/slices/sliceAddressApi';
import { useAppDispatch, useAppSelector } from '../../app/Hooks';
import { activeAddressReducer, citesDefaultReducer, citesReducer } from '../../app/slices/adressSlice';
import { errorsReducer, loadingReducer } from '../../app/slices/pagesSlice';
import { setActiveAddreReducer, setNameAddreReducer } from '../../app/slices/reportSlice';

type Props = {}

const Dashboard = (props: Props) => {
    const [getTree, { isLoading, isError }] = useGetTreeMutation()
    const [getCity] = useGetPlacesMutation()
    const { token, user } = useAppSelector(state => state.login)
    const dispatch = useAppDispatch()

    const { data: mapData } = useGetMapQuery(
        { token, total: 2000 },
        { skip: !token }
    )

    useEffect(() => {
        let a: [string, string, boolean?, boolean?][] = [['', '', false, false]]
        let b = ['', '']
        const getStartData = async () => {
            await getTree({ token }).unwrap()
                .then(res => {
                    a = res.data.map((el) => {
                        if (el.place_type_name !== 'Область') {
                            b = [el.place_name, el.place_id]
                            return [el.place_name, el.place_id, false, true]
                        }
                        else return [el.place_name + ' обл.', el.place_id, true, true]
                    })
                })
                .then(() => {
                    dispatch(citesReducer([...a]))
                    dispatch(citesDefaultReducer([...a]))
                })
            if (b[0].length > 0) {
                dispatch(activeAddressReducer([a[0][1], undefined, undefined]))
                dispatch(setActiveAddreReducer([b[1], '', '']))
                dispatch(setNameAddreReducer([b[0], '', '']))
            } else {
                await getCity({ token, placeId: a[0][1] }).unwrap()
                    .then(res => {
                        dispatch(activeAddressReducer([res.data[0].place_id, undefined, undefined]))
                        dispatch(setActiveAddreReducer([res.data[0].place_id, '', '']))
                        dispatch(setNameAddreReducer([res.data[0].place_name, '', '']))
                    })
            }
        }
        getStartData()
    }, [token, dispatch, getTree, getCity])

    useEffect(() => {
        dispatch(loadingReducer(isLoading))
    }, [isLoading, dispatch])

    useEffect(() => {
        dispatch(errorsReducer(isError))
    }, [isError, dispatch])

 
 return (
    <div className={s.dashboard}>
        <div className={s.bottomConteiner}>
            
            {/* ⬅️ ЛЕВАЯ КОЛОНКА (Сайдбар) */}
            <div className={s.topConteiner}>
                {/* 🏷 Заголовок организации переехал сюда и больше не давит на карту сверху */}
                <h2 className={s.organizationTitle}>Организация / {user.firstname}</h2>
                
                <div className={s.info}>
                    <div className={s.infoItemOne}>
                        <div className={s.infoBlockTop}>
                            <div className={s.infoTitleBlock}>
                                <p className={s.infoTitle}>Базовые станции</p>
                            </div>
                            <div className={s.infoIconBlock}>
                                <TfiSignal className={s.iconStation} />
                            </div>
                        </div>
                        <div className={s.blockStationExtended}>
                            <div className={s.statRow}>
                                <span className={s.infoText}>Всего:</span>
                                <span className={s.statNumberTotal}>
                                    {mapData && mapData.gateways ? mapData.gateways.length : 0}
                                </span>
                            </div>
                            <div className={s.statRow}>
                                <span className={s.infoTextGreen}>● В сети:</span>
                                <span className={s.statNumberGreen}>
                                    {mapData && mapData.stats ? mapData.stats.onlineCount : 0}
                                </span>
                            </div>
                            <div className={s.statRow}>
                                <span className={s.infoTextWarning}>{"● < 24ч:"}</span>
                                <span className={s.statNumberWarning}>
                                    {mapData && mapData.stats ? mapData.stats.warningCount : 0}
                                </span>
                            </div>
                            <div className={s.statRow}>
                                <span className={s.infoTextOffline}>{"● > 24ч:"}</span>
                                <span className={s.statNumberOfflineMini}>
                                    {mapData && mapData.stats ? mapData.stats.offlineCount : 0}
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className={s.infoItem}>
                        <div className={s.infoBlockTop}>
                            <div className={s.infoTitleBlock}>
                                <p className={s.infoTitle}>Приборы учета воды</p>
                            </div>
                            <div className={s.infoIconBlock}>
                                <IoWaterOutline className={s.iconStation} />
                            </div>
                        </div>
                        <div className={s.blockStation}>
                            <div className={s.networkStation}>
                                <span className={s.numberStation}>{mapData ? mapData.amount : 0}</span>
                                <span className={s.infoText}>всего</span>
                            </div>
                            <span className={s.slash}>/</span>
                            <div className={s.networkStation}>
                                <span className={s.numberStationOffline}>{mapData ? mapData.last : 0}</span>
                                <span className={s.infoText}>опрошено</span>
                            </div>
                        </div>
                        <div className={s.batteryPicDash}>
                            <div className={s.batteryLineDash}></div>
                        </div>
                    </div>

                    <div className={s.infoItem}>
                        <div className={s.infoBlockTop}>
                            <div className={s.infoTitleBlock}>
                                <p className={s.infoTitle}>Приборы учета тепла</p>
                            </div>
                            <div className={s.infoIconBlock}>
                                <PiWaves className={s.iconStationHot} />
                            </div>
                        </div>
                        <div className={s.blockStation}>
                            <div className={s.networkStation}>
                                <span className={s.numberStation}>0</span>
                                <span className={s.infoText}>всего</span>
                            </div>
                            <span className={s.slash}>/</span>
                            <div className={s.networkStation}>
                                <span className={s.numberStationOffline}>0</span>
                                <span className={s.infoText}>опрошено</span>
                            </div>
                        </div>
                        <div className={s.batteryPicDash}>
                            <div className={s.batteryLineDash}></div>
                        </div>
                    </div>

                    <div className={s.infoItem}>
                        <div className={s.infoBlockTop}>
                            <div className={s.infoTitleBlock}>
                                <p className={s.infoTitle}>Приборы учета электроэнергии</p>
                            </div>
                            <div className={s.infoIconBlock}>
                                <TfiBolt className={s.iconStation} />
                            </div>
                        </div>
                        <div className={s.blockStation}>
                            <div className={s.networkStation}>
                                <span className={s.numberStation}>0</span>
                                <span className={s.infoText}>всего</span>
                            </div>
                            <span className={s.slash}>/</span>
                            <div className={s.networkStation}>
                                <span className={s.numberStationOffline}>0</span>
                                <span className={s.infoText}>опрошено</span>
                            </div>
                        </div>
                        <div className={s.batteryPicDash}>
                            <div className={s.batteryLineDash}></div>
                        </div>
                    </div>
                </div>
            </div>

            {/* ➡️ ПРАВАЯ КОЛОНКА (Карта) */}
            <div className={s.map}>
                <Maps />
            </div>
            
        </div>
    </div>
)


}

export default Dashboard
